import { Components } from "appworks/components/components";
import { Layers } from "appworks/graphics/layers/layers";
import { gameState } from "appworks/model/game-state";
import { SpineBigWinTransition } from "appworks/transitions/spine-big-win-transition";
import { Contract } from "appworks/utils/contracts/contract";
import { BigWinComponent } from "slotworks/components/bigwin/big-win-component";

export class DMFSpineBigWinTransition extends SpineBigWinTransition {

    public in(): Contract<void> {
        const spine = this.getSpine();

        const totalWin: number = gameState.getCurrentGame().getCurrentTotalWin();
        const valueText = this.getValueText();
        if (valueText) {
            valueText.text = Components.get(BigWinComponent).format(totalWin);
        }

        return this.cancelGroup.parallel([
            () => this.zoomInternationalTextIn(),
            () => this.cancelGroup.contract((resolve) => {
                spine.playOnce(`${this.animationPrefix}${this.animationNames.in}`).then(() => {
                    spine.play(`${this.animationPrefix}${this.animationNames.loop}`);
                    resolve();
                });
            })
        ]);
    }

    protected getValueText() {
        return Layers.get(Components.get(BigWinComponent).contentLayerName).getText("value")
            || Layers.get(Components.get(BigWinComponent).contentLayerName).getBitmapText("value")
            || Layers.get(Components.get(BigWinComponent).foregroundLayerName)?.getText("value")
            || Layers.get(Components.get(BigWinComponent).foregroundLayerName)?.getBitmapText("value")
            || Layers.get(Components.get(BigWinComponent).backgroundLayerName)?.getText("value")
            || Layers.get(Components.get(BigWinComponent).backgroundLayerName)?.getBitmapText("value")
            || null;
    }
}
